import { render } from "./LocalGroups.vue?vue&type=template&id=3cb38704"
import script from "./LocalGroups.vue?vue&type=script&lang=js"
export * from "./LocalGroups.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__